<template>

	<div>

		<div class="bg-image-landscape bg-cover bg-top text-center">

			<!-- Text Input -->
			<div class="mt-12 pb-12 flex justify-center text-gray-700">

				<div class="relative">
					<div class="p-12 bg-primary shadow-lg">
						<div class="uppercase text-xs text-white text-left">Your name / Your company name:</div>
						<div>
							<input
								v-model="name"
								@input="handleTextTyped( 'name', name )"
								:placeholder="'eg. ' + defaultName"
								type="text"
								class="text-xl p-2 sm:w-96 mt-2">
						</div>
						<div class="uppercase text-xs mt-4 text-white text-left">Your tagline:</div>
						<div>
							<input
								v-model="tagline"
								@input="handleTextTyped( 'tagline', tagline )"
								:placeholder="'eg. '+defaultTagline"
								type="text"
								class="text-xl p-2 sm:w-96 mt-2">
						</div>
					</div>
					<div class="bottom-arrow"></div>
				</div>

			</div>

		</div>

		<div class="bg-gray-100">

			<!-- Preview -->
			<div class="flex justify-center">
				<signature
					:initial-text-fonts="initialTextFonts"
					:initial-signature-fonts="initialSignatureFonts"
					:attributes="preview"
					:canvas-width="$root.isMobile() ? 320 : 800"
					:canvas-height="$root.isMobile() ? 100 : 250"
					:name="name"
					:tagline="tagline"
					@updateSample="updateSignatureOnSample"></signature>
			</div>

		</div>

		<div class="bg-gray-100 -mb-1">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 120 1440 200">
				<path fill="#e2e8f0" fill-opacity="1"
					  d="M0,224L40,224C80,224,160,224,240,197.3C320,171,400,117,480,122.7C560,128,640,192,720,202.7C800,213,880,171,960,149.3C1040,128,1120,128,1200,144C1280,160,1360,192,1400,208L1440,224L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path>
			</svg>
		</div>

		<div class="bg-gray-200 text-center pb-8">

			<!-- Heading -->
			<div class="mb-8">
				<h1 class="px-4 text-5xl sm:text-4xl sm:text-5xl leading-none text-gray-700">
					Signature <span class="whitespace-nowrap font-bold">logo variations</span>
				</h1>
				<h2 class="hidden sm:inline-block text-xl leading-normal text-gray-600 mt-2">
					Sample signature logos for '<b>{{ name !== '' ? name : defaultName }}</b>' with tagline
					'<b>{{ tagline !== '' ? tagline : defaultTagline }}</b>'
				</h2>
			</div>

			<div>
				<!-- Samples -->
				<div class="flex flex-wrap justify-center">
					<signature
						v-for="(sample, index) in samples"
						:key="index"
						:index="index"
						:initial-text-fonts="initialTextFonts"
						:initial-signature-fonts="initialSignatureFonts"
						:attributes="sample"
						:canvas-width="400"
						:canvas-height="150"
						:name="name"
						:tagline="tagline"
						:funnel="funnel"
						:border="true"></signature>
				</div>
			</div>

			<!-- Heading -->
			<div class="mb-8">
				<h2 class="hidden sm:inline-block text-xl leading-normal mt-8">
					+ many more. Over a million style variations to explore.
				</h2>
			</div>

		</div>

		<div class="bg-gray-200 -mb-1">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 120 1440 200">
				<path fill="#000000" fill-opacity="1"
					  d="M0,224L40,224C80,224,160,224,240,197.3C320,171,400,117,480,122.7C560,128,640,192,720,202.7C800,213,880,171,960,149.3C1040,128,1120,128,1200,144C1280,160,1360,192,1400,208L1440,224L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path>
			</svg>
		</div>

		<div class="bg-black text-center pb-8">

			<!-- Heading -->
			<div class="mb-8">
				<h1 class="px-4 text-2xl sm:text-5xl sm:text-4xl sm:text-5xl leading-none text-white">
					Signature logo preview
				</h1>
				<h2 class="hidden sm:inline-block text-xl leading-normal text-white mt-2">
					Here's a preview of what your signature logo would look like on a photo sample.
				</h2>
			</div>

			<div>
				<!-- Sample -->
				<div class="flex flex-wrap justify-center">
					<div class="relative">
						<img src="/images/samples/sample.jpg" class="sm:max-w-4xl">
						<div class="absolute right-5 sm:-right-10 top-5 sm:top-10">
							<img :src="samplesrc"
								 :width="$root.isMobile() ? 200 : 600"
								 :height="$root.isMobile() ? 66 : 200"
								 class="pointer-events-none">
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="bg-black -mb-1">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 120 1440 200">
				<path fill="#ffffff" fill-opacity="1"
					  d="M0,224L40,224C80,224,160,224,240,197.3C320,171,400,117,480,122.7C560,128,640,192,720,202.7C800,213,880,171,960,149.3C1040,128,1120,128,1200,144C1280,160,1360,192,1400,208L1440,224L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path>
			</svg>
		</div>

		<!-- CTA -->
		<div class="bg-white pt-2">
			<div class="container max-w-screen-lg px-8 py-4">
				<div class="text-center">
					<p class="text-2xl text-primary-darkest">
						Create your custom signature logo today.
					</p>
					<div class="flex flex-wrap justify-center pt-6 text-xl">
						<a href="javascript:void(0);" @click="upgrade" class="button-primary p-8">Get Started
							<i class="fa fa-fw fa-long-arrow-right"></i></a>
					</div>
				</div>
			</div>
		</div>

	</div>

</template>

<script>

	import Signature from "../External/Signature.vue";

	export default {

		components: {
			'signature': Signature,
		},

		props: {
			funnel: {
				type: String,
				default: '',
			},
			presetName: {
				type: String,
				default: '',
			},
			presetTagline: {
				type: String,
				default: '',
			},
			initialTextFonts: { // Only used on Editor
				type: Array,
				default: () => [],
			},

			initialSignatureFonts: {  // Only used on Editor
				type: Array,
				default: () => [],
			},
		},

		data()
		{
			return {
				defaultName: 'Julianne Michael',
				defaultTagline: 'photography',
				name: this.presetName,
				tagline: this.presetTagline,
				samplesrc: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
				preview: {
					0: { // name
						y: -50,
						baseline: -5,
						// font_size default = 50
					},
					1: { // tagline
						font_size: 14, // font_size default = 12
						// font_id default = 250 ( Open Sans )
					}
				},
				sample: {
					0: { // name
						y: -50,
						baseline: -5,
						//font_size: 30, // font_size default = 50
					},
					1: { // tagline
						image: true, // create data image
						font_size: 14, // font_size default = 12
					}
				},
				samples: {
					0: {
						0: {
							font_id: 28,
							baseline: -20, // default baseline of signature is border box bottom, but the real baseline isn't always in that position
						},
						1: {}
					},
					1: {
						0: {
							font_id: 29,
							baseline: -20,
						},
						1: {}
					},
					2: {
						0: {
							font_id: 6,
							font_size: 20,
							font_weight: 'bold',
							baseline: 0,
						},
						1: {}
					},
					3: {
						0: {
							font_id: 22,
							baseline: -15,
						},
						1: {}
					},
					4: {
						0: {
							font_id: 13,
							font_size: 70,
							baseline: 0,
						},
						1: {}
					},
					5: {
						0: {
							font_id: 17,
							baseline: -20,
						},
						1: {}
					},
					6: {
						0: {
							font_id: 5,
							font_size: 25,
							font_weight: 'bold',
							baseline: -5,
						},
						1: {}
					},
					7: {
						0: {
							font_id: 26,
							font_size: 60,
							baseline: -10,
						},
						1: {}
					},
					8: {
						0: {
							font_id: 19,
							font_size: 60,
							baseline: -17,
						},
						1: {}
					},
					9: {
						0: {
							font_id: 10,
							baseline: -5,
						},
						1: {}
					},
					10: {
						0: {
							font_id: 11,
							font_size: 35,
							baseline: 5,
						},
						1: {}
					},
					11: {
						0: {
							font_id: 14,
							baseline: 5,
						},
						1: {}
					},
				}
			}
		},

		computed: {},

		methods: {

			upgrade()
			{

				if (this.funnel === 'landing_signature') {
					location.href = '/register?plan=premium&funnel=landing_signature';
				} else {
					location.href = '/start';
				}

			},

			handleTextTyped(type, value)
			{
				this[type] = value;
			},

			updateSignatureOnSample(data)
			{

				this.samplesrc = data;

			}

		},

		mounted()
		{
		}
	}
</script>

<style>
.bottom-arrow {
	border-bottom: 15px solid #4A90E2;
}

.bottom-arrow:after {
	content: '';
	position: absolute;
	bottom: -25px;
	left: 0;
	right: 0;
	margin: 0 auto;
	width: 0;
	height: 0;
	border-top: 25px solid #4A90E2;
	border-left: 25px solid transparent;
	border-right: 25px solid transparent;
}
</style>